module.exports = __webpack_public_path__ + "img/stachura.fdbaed26.jpg";